export default __webpack_public_path__ + "static/lib-storage-1f514fbf66b95bc37f10b73d0ab5afc6.jpg";